import { getURLFileExtension } from "utils/StringUtils";

export const getFileName = (file) => {
  const { fileId: f_id, name = "", url, id } = file ?? {};
  const fileURL = url ?? "";
  const fileId = f_id || id || "";
  const fileEXT = getURLFileExtension(fileURL || "");

  if (!name) return `${fileId}.${fileEXT}`;
  if (!name.includes(fileEXT)) return `${name}.${fileEXT}`;
  return name;
};
